const OPEN_ENDED_NEXT_WEIGHT = 99999999.99;

const toRoundedLabelNumber = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return String(Math.round(numericValue));
};

export const formatBandHeader = ({ weight, nextWeight }) => {
  const start = toRoundedLabelNumber(weight);
  const endValue = Number(nextWeight);

  if (endValue >= OPEN_ENDED_NEXT_WEIGHT) {
    return `${start}+ кг`;
  }

  return `${start}-${Math.ceil(endValue)} кг`;
};

export const buildBandColumnKey = ({ weight, nextWeight }) =>
  `${Number(weight).toFixed(2)}_${Number(nextWeight).toFixed(2)}`;

export const buildCarrierGroups = (registryRows = []) => {
  const grouped = registryRows.reduce((accumulator, row) => {
    const carrierKey = row?.carrierType || "Без группы";
    const currentRows = accumulator.get(carrierKey) || [];

    currentRows.push({
      ...row,
      id: row?.id ?? row?.crossDockingPointId ?? row?.kato,
    });
    accumulator.set(carrierKey, currentRows);
    return accumulator;
  }, new Map());

  return Array.from(grouped.entries())
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, rows]) => ({
      key,
      label: key,
      rows,
      crossDockingPointIds: rows.map((row) => row.id),
    }));
};

export const joinRegistryWithTariffs = ({ registryRows = [], tariffRows = [] }) => {
  const tariffRowsByPointId = new Map(
    tariffRows.map((row) => [row.crossDockingPointId, row])
  );

  return registryRows.map((registryRow) => {
    const rowId = registryRow?.id ?? registryRow?.crossDockingPointId ?? registryRow?.kato;
    const matchedTariffRow = tariffRowsByPointId.get(rowId);

    return {
      crossDockingPointId: rowId,
      carrierType: registryRow?.carrierType || "Без группы",
      locality: registryRow?.locality || "\u2014",
      kato: matchedTariffRow?.kato || registryRow?.kato || "\u2014",
      address: registryRow?.address || "",
      isActive: Boolean(registryRow?.isActive),
      cells: matchedTariffRow?.cells || {},
    };
  });
};

export const buildDirtyPatchPayload = (dirtyRows = []) => ({
  rows: dirtyRows.map((row) => ({
    rowKey: {
      crossDockingPointId: row.crossDockingPointId,
      kato: row.kato,
    },
    changes: (row.changes || []).map((change) => ({
      id: change.id,
      price: Number(change.price),
      expectedUpdatedAt: change.updatedAt,
    })),
  })),
});
